import type { Contrato } from "@/componentes/contratos/TarjetaContrato"
import { comoFecha } from "@/lib/fechas"

/**
 * Lo que dice el contrato.
 *
 * ⚠ **Un borrador y un emitido no enseñan lo mismo, y por eso se distinguen.** El
 * borrador lee en vivo: lo que se ve es lo que se congelaría al emitir. El emitido
 * enseña lo firmado, y encima el aviso de si el puesto sigue diciendo eso hoy.
 * Pintar los dos casos igual haría creer que lo de un borrador ya está fijado.
 */
export function Funciones({
  contrato,
  previa,
  cargando,
  fallo,
}: {
  contrato: Contrato
  previa?: { funciones: string[]; difiere: boolean }
  cargando: boolean
  fallo: boolean
}) {
  const firmado = contrato.funciones !== null
  const lista = firmado ? (contrato.funciones ?? []) : (previa?.funciones ?? [])

  return (
    <div className="mt-3 border-t pt-3" style={{ borderColor: "var(--border)" }}>
      <p className="mb-1 text-xs font-medium uppercase" style={{ color: "var(--fg-muted)" }}>
        {firmado
          ? `Funciones firmadas${contrato.emitido_en ? ` · ${comoFecha(contrato.emitido_en)}` : ""}`
          : "Funciones de hoy · todavía no firmadas"}
      </p>

      {cargando && !firmado && (
        <p className="text-sm" style={{ color: "var(--fg-muted)" }}>
          Cargando…
        </p>
      )}

      {fallo && !firmado && (
        <p role="alert" className="text-sm" style={{ color: "var(--destructive)" }}>
          No se pudo leer el descriptivo del cargo.
        </p>
      )}

      {lista.length > 0 && (
        <ul className="ml-4 list-disc text-sm">
          {lista.map((f) => (
            <li key={f}>{f}</li>
          ))}
        </ul>
      )}

      {!firmado && !cargando && !fallo && lista.length === 0 && (
        <p className="text-sm" style={{ color: "var(--destructive)" }}>
          El cargo no tiene ninguna función. Descríbelas en Procesos o en el catálogo antes de
          emitir: un contrato de trabajo que no dice qué trabajo no se emite.
        </p>
      )}

      {firmado && previa?.difiere === true && (
        <p
          className="mt-2 text-xs"
          style={{ color: "var(--warning)" }}
          data-testid={`difiere-${contrato.id}`}
        >
          El puesto ya no dice lo mismo que este contrato. Lo firmado no se toca; si el cambio
          importa, hace falta un anexo o un contrato nuevo.
        </p>
      )}
    </div>
  )
}
